export default __webpack_public_path__ + "343160b41b81ca3f493106f11a0827f0.png";